import {
  Required,
  Schema,
  TextField,
  RemoteDataSource,
  ForeignKeyField,
  EnumField
} from "lego-gui-lib/lib";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { Auth } from "../../core/model/auth";

export const RolesEnum = [
  { label: t("hns:auth:roles:platform_admin"), value: 0 },
  { label: t("hns:auth:roles:admin"), value: 1 },
  { label: t("hns:auth:roles:san_admin"), value: 2 },
  { label: t("hns:auth:roles:san_admin_read_only"), value: 3 },
  { label: t("hns:auth:roles:customer"), value: 4 },
  { label: t("hns:auth:roles:customer_read_only"), value: 5 },
  { label: t("hns:auth:roles:customer_spec_hg"), value: 6 }
];

export const WebUserRoleSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name")
    },
    {
      name: "roleType",
      type: EnumField(RolesEnum, Required),
      title: t("common:type")
    }
  ]
});

mainStore.webUserRole = RemoteDataSource.create({
  api: api,
  name: "webUserRole",
  schema: WebUserRoleSchema,
  url: "/webUserRoles",
  commons: mainStore.commons
});

mainStore.webUserRoleCustomerOnly = RemoteDataSource.create({
  api: api,
  name: "webUserRole",
  schema: WebUserRoleSchema,
  url: "/webUserRoles",
  commons: mainStore.commons,
  params: {
    filters: [
      {
        field: "roleType",
        value: "4,5,6"
      }
    ]
  }
});

export const WebUserRoleCustomerOnlyFk = ForeignKeyField(
  {
    dataSource: mainStore.webUserRoleCustomerOnly.listDataSource,
    labelField: "name",
    valueField: "id",
    minWidth: 120
  },
  Required
);

mainStore.webUserRoleAdminOnly = RemoteDataSource.create({
  api: api,
  name: "webUserRole",
  schema: WebUserRoleSchema,
  url: "/webUserRoles",
  commons: mainStore.commons,
  params: {
    filters: [
      {
        field: "roleType",
        // PLATFORM_ADMIN(0),
        // ADMIN(1),
        // SAN_ADMIN(2)
        // SAN_ADMIN_READONLY(3)
        value: "0,1,2,3"
      }
    ]
  }
});

export const WebUserRoleAdminOnlyFk = ForeignKeyField(
  {
    dataSource: mainStore.webUserRoleAdminOnly.listDataSource,
    labelField: "name",
    valueField: "id",
    minWidth: 120
  },
  Required
);
